import { render, staticRenderFns } from "./EditorTitlePanel.vue?vue&type=template&id=0a88b43c&scoped=true"
import script from "./EditorTitlePanel.vue?vue&type=script&lang=js"
export * from "./EditorTitlePanel.vue?vue&type=script&lang=js"
import style0 from "./EditorTitlePanel.vue?vue&type=style&index=0&id=0a88b43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88b43c",
  null
  
)

export default component.exports